<nb-card class="dialog-card mensagem-detalhe">
  <nb-card-header>
    <span class="titulo">Mensagem</span>
    <span class="subtitulo" *ngIf="mensagem">
      {{ mensagem.criadoEm ? (mensagem.criadoEm | date: 'dd/MM/yyyy HH:mm') : '' }}
      · {{ mensagem.status }} — postada não é entregue
    </span>
  </nb-card-header>

  <nb-card-body>
    <div class="carregando" *ngIf="carregando">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Carregando…</span>
    </div>

    <p class="erro" *ngIf="erro">{{ erro }}</p>

    <ng-container *ngIf="mensagem && !carregando">
      <dl class="dados">
        <div><dt>Destinatário</dt><dd>{{ mensagem.destinatario || '—' }}</dd></div>
        <div><dt>Canal</dt><dd>{{ mensagem.canal || '—' }}</dd></div>
        <div><dt>Tentativas</dt><dd>{{ mensagem.tentativas != null ? mensagem.tentativas : '—' }}</dd></div>
        <div class="largo"><dt>Resposta do serviço</dt><dd>{{ mensagem.respostaServico || '(vazia)' }}</dd></div>
        <div class="largo" *ngIf="mensagem.erro"><dt>Erro</dt><dd class="texto-erro">{{ mensagem.erro }}</dd></div>
      </dl>

      <section class="bloco">
        <h3 class="bloco-titulo">Parâmetros</h3>
        <p class="bloco-ajuda">
          Só o que mudar é enviado. Trocar o remetente e reenviar é como se descobre qual
          combinação o serviço aceita, sem mexer na configuração da aplicação.
        </p>

        <label class="field-label" for="msg-remetente">Remetente</label>
        <input nbInput fullWidth id="msg-remetente" name="remetente" [(ngModel)]="remetente" />

        <label class="field-label" for="msg-assunto">Assunto</label>
        <input nbInput fullWidth id="msg-assunto" name="assunto" [(ngModel)]="assunto" />

        <label class="field-label" for="msg-url">URL</label>
        <input nbInput fullWidth id="msg-url" name="url" [(ngModel)]="url" />

        <div class="bloco-acoes">
          <button nbButton size="small" status="primary" type="button" [disabled]="salvando" [nbSpinner]="salvando" (click)="salvarParametros()">
            Salvar parâmetros
          </button>
        </div>
      </section>

      <section class="bloco">
        <h3 class="bloco-titulo">Reenviar</h3>
        <p class="bloco-ajuda">
          O reenvio <strong>não cria registro novo</strong> e não altera esta mensagem: é
          ferramenta de diagnóstico, e o histórico continua mostrando só os envios reais.
        </p>

        <nb-checkbox [(ngModel)]="paraOutro" name="paraOutro">Reenviar para outro e-mail</nb-checkbox>

        <div class="campo-outro" *ngIf="paraOutro">
          <label class="field-label" for="msg-outro">E-mail de destino</label>
          <input nbInput fullWidth id="msg-outro" name="outroDestinatario" type="email"
                 placeholder="seu@exemplo.com" [(ngModel)]="outroDestinatario" />
        </div>

        <div class="bloco-acoes">
          <button nbButton size="small" status="warning" type="button" [disabled]="reenviando" [nbSpinner]="reenviando" (click)="reenviar()">
            <nb-icon pack="eva" icon="paper-plane-outline"></nb-icon>
            <span>{{ paraOutro ? 'Reenviar para o outro e-mail' : 'Reenviar para o mesmo destinatário' }}</span>
          </button>
        </div>

        <p class="resultado-reenvio" *ngIf="resultadoReenvio">{{ resultadoReenvio }}</p>
      </section>

      <section class="bloco">
        <h3 class="bloco-titulo">Corpo</h3>
        <p class="bloco-ajuda">
          Conteúdo isolado: o HTML abaixo é exibido em quadro próprio, sem scripts e sem acesso a
          esta página. Ele contém dados pessoais de quem se inscreveu.
        </p>
        <iframe
          class="corpo-isolado"
          sandbox
          title="Corpo da mensagem"
          [srcdoc]="corpoSeguro"
        ></iframe>
      </section>
    </ng-container>
  </nb-card-body>

  <nb-card-footer class="footer-actions">
    <button nbButton status="primary" size="medium" type="button" (click)="fechar()">Fechar</button>
  </nb-card-footer>
</nb-card>
